import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { InventarioLayoutComponent } from './layout/layout.component';
import { InventarioKezdolapComponent } from './kezdolap/kezdolap.component';
import { CikkekComponent } from './cikkek/cikkek.component';
import { KeszletComponent } from './keszlet/keszlet.component';
import { MozgasokComponent } from './mozgasok/mozgasok.component';
import { LeltarComponent } from './leltar/leltar.component';
import { InventarioBeallitasokComponent } from './beallitasok/beallitasok.component';
import { InventarioErtekelesComponent } from './ertekeles/ertekeles.component';
import { ProfilMenuComponent } from '../components/profil-menu/profil-menu.component';
import { UgyfelkorBeallitasComponent } from '../components/ugyfelkor-beallitas/ugyfelkor-beallitas.component';
import { KameraOlvasoComponent } from '../components/kamera-olvaso/kamera-olvaso.component';
import { SzerkZarSavComponent } from '../components/szerk-zar/szerk-zar-sav.component';

// KÉSZLETKEZELÉS (INVENTARIO) – önálló alrendszer; a NAPLO-ügyfelek készlete, a Számla és Kasszával
// közös cikktörzzsel (backend: inventario.js, /api/inventario). Arculat: borostyán (#b96800).
const K = [InventarioLayoutComponent, InventarioKezdolapComponent, CikkekComponent, KeszletComponent, MozgasokComponent, LeltarComponent, InventarioBeallitasokComponent, InventarioErtekelesComponent];
@NgModule({
  declarations: K,
  imports: [CommonModule, FormsModule, RouterModule, IonicModule, ProfilMenuComponent, UgyfelkorBeallitasComponent, KameraOlvasoComponent, SzerkZarSavComponent],
  exports: K,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InventarioModule {}
